/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
export const NextArrow = (props: any) => {
    const { className, onClick } = props;
    return (
        <button onClick={onClick} className={className}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.42139 3.93738L14.4839 8.99988L9.42139 14.0624"
                    strokeWidth="1.00189"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13.7812 9H3.51562" strokeWidth="1.00189" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
    );
};

export const PrevArrow = (props: any) => {
    const { className, onClick } = props;
    return (
        <button onClick={onClick} className={className}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.57861 3.93738L3.51611 8.99988L8.57861 14.0624"
                    strokeWidth="1.00189"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M4.21875 9H14.4844" strokeWidth="1.00189" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
    );
};
export const ExpandMoreIcon = () => {
    return (
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.04518 7.11623C2.27959 6.88189 2.59748 6.75024 2.92893 6.75024C3.26039 6.75024 3.57827 6.88189 3.81268 7.11623L10.0002 13.3037L16.1877 7.11623C16.4234 6.88853 16.7392 6.76254 17.0669 6.76538C17.3947 6.76823 17.7082 6.89969 17.94 7.13145C18.1717 7.36321 18.3032 7.67673 18.306 8.00448C18.3089 8.33222 18.1829 8.64797 17.9552 8.88373L10.8839 15.955C10.6495 16.1893 10.3316 16.321 10.0002 16.321C9.66873 16.321 9.35084 16.1893 9.11643 15.955L2.04518 8.88373C1.81084 8.64932 1.6792 8.33143 1.6792 7.99998C1.6792 7.66852 1.81084 7.35064 2.04518 7.11623Z" />
        </svg>
    );
};
